export const environment = {
  production: true,
  jwtTokenCookieName: 'com.britishchristian.token',
  userIdCookieName: 'com.britishchristian.userId',
  webApiNamespace: "/web/api",
  imports:[]
};
